export default __webpack_public_path__ + "static/media/icon-billing.8fa5cd7b.svg";